import { ENGINE_CAPABILITIES } from '../../product/capabilities';

export function CapabilityMatrix(): React.JSX.Element {
  return (
    <section className="capability-section" aria-labelledby="capability-title">
      <header className="capability-section__header">
        <div>
          <p className="mono label">IMPLEMENTED ENGINE SCOPE</p>
          <h2 id="capability-title">Exactly what MendByte can do</h2>
        </div>
        <p>Six bounded recovery engines. “Safe repair” means only the listed evidence-backed rules—not a promise to fix every damaged file.</p>
      </header>
      <div className="capability-matrix-wrap" tabIndex={0} role="region" aria-label="MendByte engine capability matrix">
        <table className="capability-matrix">
          <caption className="visually-hidden">Analyze, safe repair, content rescue, encryption handling, and deliberate boundaries for each MendByte engine.</caption>
          <thead>
            <tr>
              <th scope="col">Format</th>
              <th scope="col">Analyze</th>
              <th scope="col">Safe repair</th>
              <th scope="col">Content rescue</th>
              <th scope="col">Encryption</th>
              <th scope="col">Deliberate boundaries</th>
            </tr>
          </thead>
          <tbody>
            {ENGINE_CAPABILITIES.map((capability) => (
              <tr key={capability.engine}>
                <th scope="row"><strong>{capability.engine}</strong><span>{capability.formats}</span></th>
                <td data-label="Analyze">{capability.analyze}</td>
                <td data-label="Safe repair"><span className="capability-status">Bounded</span> {capability.safeRepair}</td>
                <td data-label="Content rescue">{capability.contentRescue}</td>
                <td data-label="Encryption"><span className="capability-status capability-status--detection">Detection only</span> {capability.encryption}</td>
                <td data-label="Deliberate boundaries">{capability.boundaries}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="capability-section__legacy"><strong>Not accepted:</strong> legacy XLS, DOC, and PPT; ODS and ODP. <strong>Detection only:</strong> encrypted or password-to-open content is not unlocked, decrypted, or extracted. Keep the original file unchanged.</p>
    </section>
  );
}
